<footer class="page-footer font-small bg-dark p-2">
    <div class="footer-copyright text-center py-2" role="alert">
        <p>{{ translateLabelWithParams() | async}}</p>
    </div>
</footer>
